<template>
<div>
    <div v-if="!loading" style="height: 200px; overflow-y: scroll;">
        <b-table small hover :fields="tablefields" :items="data" responsive="sm" primary-key="time">
            <template #cell(index)="data">{{ data.index + 1 }}</template>

            <!-- <template #cell(rx)="data">
                {{myFileSize(data.value, exponent_rx)}}
            </template> -->

            <template slot="bottom-row">
                <td>&nbsp;</td>
                <td align=center><b>Total</b></td>
                <td><b>{{this.t_rx_bytes.toFixed(2)}}</b></td>
                <td><b>{{this.t_tx_bytes.toFixed(2)}}</b></td>
            </template>
        </b-table>
    </div>
</div>
</template>

<script>
import filesize from 'filesize'; //https://filesizejs.com/

export default {
    props: {
        period: {
            type: String,
            default: 'D'
        },
    },
    data() {
        return {
            data: '',
            loading: true,
            tablefields: [
                { key: 'index', label: '#' },
                { key: 'time', label: this.timeTitle(this.period) },
                { key: 'rx', label: "Upload (GB)" },
                { key: 'tx', label: "Download (GB)" },
            ],
            t_tx_bytes: 0,
            t_rx_bytes: 0,
            max_rx: 0,
            max_tx: 0,
            exponent_rx: 3,
            exponent_tx: 3,

        }
    },
    methods: {
        timeTitle(period) {
            if (period === "D") return 'Time (YYYY-MM-DD HH)';
            else if (period === "M") return 'Time (YYYY-MM-DD)';
            else if (period === "Y") return 'Time (YYYY-MM)';
            else return 'Time';

        },
        myFileSize(value, exponent) {
            return filesize(value, { exponent: exponent });
        },
        getData() {
            this.loading = true;
            let uri = `/api/dashboard?node=wan_traffic&period=${this.period}`;

            axios.get(uri)
                .then(response => {
                    this.data = response.data.data;
                    if (this.data) {

                        this.loading = false;
                        this.data.forEach(row => {
                            this.t_rx_bytes += parseFloat(row.rx);
                            this.t_tx_bytes += parseFloat(row.tx);

                            // this.max_rx = this.max_rx === null ? row.rx : Math.max(this.max_rx, row.rx);
                            // this.max_tx = this.max_tx === null ? row.tx : Math.max(this.max_tx, row.tx);
                        });
                        // console.log('MAX RX:' + this.max_rx);
                        // this.exponent_rx = filesize(this.max_rx, { output: "exponent" });
                        // console.log('Rx:' + this.max_rx + ' ' + this.exponent_rx);
                        // this.exponent_tx = filesize(this.max_tx, { output: "exponent" });

                    } else {
                        console.log('NO DATA 2');
                    }
                }).catch(error => {

                    if (error.response) {
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        // console.log(error.response.data);
                        // console.log(error.response.status);
                        // console.log(error.response.headers);
                    } else if (error.request) {
                        // The request was made but no response was received
                        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                        // http.ClientRequest in node.js
                        // console.log(error.request);
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        console.log('Error', error.message);
                    }
                    console.log(error.config);

                })

        },

    },

    mounted() {
        this.getData();
    },

}
</script>
